// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","header-texto":"Header_header-texto__E9Jwd","header-button":"Header_header-button__WwSef","header-imagem":"Header_header-imagem__ptd2s"};